import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';

const ADMIN_BASKETS_APP_ROOT = `${BASE_ADMIN_V2_PATH}/baskets`;

export const ADMIN_BASKETS_APP_PATHS = {
  BASKETS_LIST: `${ADMIN_BASKETS_APP_ROOT}`,
  BASKET_DETAILS: (basketId: string) => `${ADMIN_BASKETS_APP_ROOT}/${basketId}/details`,
};

export const BASKET_IMAGE_PATH = (path: string) => `${process.env.REACT_APP_AWS}/${path}`;
